import React, { Component } from 'react';
import { connect } from 'react-redux'

import ListSelect from './controls/ListSelect.jsx';
import GridSelect from './controls/GridSelect.jsx';
import TextInput from './controls/TextInput.jsx';
import Toggle from './controls/Toggle.jsx';
import ImageUpload from './controls/ImageUpload.jsx';

import Data from './data/index';

// import cloudinaryHelp from './data/CloudinaryHelp.js';

let component;

class Controls extends Component {

  constructor(props) {
    super(props);

    this.state = {backgrounds:[]};

    component = this;

    this.updateImages();

  }

  _handleUpdate(response) {
    console.log('Response for Update Images');

    response.json().then(
      function(json){

        for (var key in json.resources) {
          json.resources[key].type = "image";
          json.resources[key].id = json.resources[key]['public_id'];
        }

        var dateA, dateB;

        function sortFunction(a,b){  
            dateA = new Date(a['created_at']).getTime();
            dateB = new Date(b['created_at']).getTime();
            return dateA < dateB ? 1 : -1;  
        }; 

        json.resources.sort(sortFunction);

        component.setState({backgrounds: json.resources});
      }
    )
  }

  updateImages() {
    console.log('Update Background Images');
    fetch('http://107.170.196.140/images', {
      'method': 'GET',
    }).then(component._handleUpdate, function(e) {console.log('error', e)});
  }

  render() {
    return (
    <div className="Controls">
      <TextInput name="Phrase" value={this.props.phrase} onChange={this.props.changePhrase} />
      <ListSelect name="Platform" items={ Data.Platforms } select={this.props.platform} onChange={this.props.changePlatform} doHalf={true} />
      <ListSelect name="Font" items={ Data.Fonts } select={this.props.font} onChange={this.props.changeFont} doHalf={true} />
      <ListSelect name="Size" items={ Data.Sizes } select={this.props.size} onChange={this.props.changeSize} doHalf={true} />
      <GridSelect name="Align" items={ Data.Align } onChange={this.props.changeAlign} size={"small"} doHalf={true} />
      <Toggle name="Bold" onChange={this.props.changeBold} toggled={this.props.bold} icon="bold" doHalf={true}/>
      <Toggle name="Italic" onChange={this.props.changeItalic} toggled={this.props.italic} icon="italic" doHalf={true}/>
      <GridSelect name="Background" items={ this.state.backgrounds } onChange={this.props.changeBackground} size={"medium"} />
      <GridSelect name="Color Overlay" items={ Data.Colors } onChange={this.props.changeColor} size={"small"} />
      <ImageUpload onAdd={ this.updateImages }/>
    </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    background: state.background,
    font: state.font,
    platform: state.platform,
    phrase: state.phrase,
    size: state['fontSize'],
    url: state.url,
    bold: state.isBold,
    italic: state.isItalic
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    changePlatform: (e) => [
      dispatch({type:'CHANGE_PLATFORM', value: e.target.value}),
      dispatch({type:'URL_GENERATE'})
    ],
    changeFont: (e) => [
      dispatch({type:'CHANGE_FONT', value: e.target.value}),
      dispatch({type:'URL_GENERATE'})
    ],
    changeSize: (e) => [
      dispatch({type:'CHANGE_SIZE', value: e.target.value}),
      dispatch({type:'URL_GENERATE'})
    ],
    changeBackground: (value) => [
      dispatch({type:'CHANGE_BACKGROUND', value: value}),
      dispatch({type:'URL_GENERATE'})
    ],
    changeAlign: (value) => [
      dispatch({type:'CHANGE_ALIGN', value: value}),
      dispatch({type:'URL_GENERATE'})
    ],
    changePhrase: (e) => [
      dispatch({type:'CHANGE_PHRASE', value: e.target.value}),
      dispatch({type:'URL_GENERATE'})
    ],
    changeBold: (value) => [
      dispatch({type:'CHANGE_BOLD', value: value}),
      dispatch({type:'URL_GENERATE'})
    ],
    changeItalic: (value) => [
      dispatch({type:'CHANGE_ITALIC', value: value}),
      dispatch({type:'URL_GENERATE'})
    ],
    changeColor: (value) => [
      dispatch({type:'CHANGE_COLOR', value: value}),
      dispatch({type:'URL_GENERATE'})
    ]
  }
}

Controls = connect(
  mapStateToProps,
  mapDispatchToProps
)(Controls);

export default Controls;



// WEBPACK FOOTER //
// ./src/Controls.jsx